module.exports = __webpack_public_path__ + "img/FavoriteBorderOutlined.4cc2a8b3.svg";